import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Order as SchemaOrder } from '../schemas/Order';
import { type Problem as SchemaProblem } from '../schemas/Problem';
import { type ReassignOrderLoyaltyProblemType as SchemaReassignOrderLoyaltyProblemType } from '../schemas/ReassignOrderLoyaltyProblemType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Finds or creates a user by Yandex ID from session cookie, registers them in the loyalty program, reassigns the order to that user, and recalculates loyalty
 * @summary Register user in loyalty program, reassign order and recalculate loyalty
 */
export const RegisterLoyaltyAndReassignOrderContentType = '' as const;
export type RegisterLoyaltyAndReassignOrderRequest = undefined;
export type RegisterLoyaltyAndReassignOrderResponses = LinkCommonErrorResponses & {
    /**
     * @description User registered in loyalty program, order reassigned and loyalty recalculated successfully
     */
    '200': {
        'application/json': SchemaOrder;
    };
    /**
     * @description Bad request
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaReassignOrderLoyaltyProblemType;
        };
    };
};
export type RegisterLoyaltyAndReassignOrderResponseSuccess =
    RegisterLoyaltyAndReassignOrderResponses['200']['application/json'];
export type RegisterLoyaltyAndReassignOrderSearchParams = {
    signature: string;
};
export type RegisterLoyaltyAndReassignOrderPathParameters = {
    store_slug: string;
    order_id: string;
};
export const RegisterLoyaltyAndReassignOrderUrl =
    '/{store_slug}/orders/{order_id}/loyalty/register_and_reassign' as const;
export const RegisterLoyaltyAndReassignOrderMethod = 'POST' as const;
export const getRegisterLoyaltyAndReassignOrderUrl = (params: RegisterLoyaltyAndReassignOrderPathParameters) =>
    RegisterLoyaltyAndReassignOrderUrl.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof RegisterLoyaltyAndReassignOrderPathParameters) => String(params[param])
    );
